import React, { Component } from 'react';
import LogoNordeste from '../imagens/logo nordeste pequeno.jpg';


export default class extends Component {
    state = {  }
    render() {
        return (
            <div style={{height: 500 }}>
                {/* <h2>Página Home</h2> */}
                <img 
                    className="home-menu-logo"
                    alt="Expresso Nordeste" 
                    src={LogoNordeste} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePage.js